import { faro } from '@grafana/faro-web-sdk';

/**
 * Attaches the logged-in user to all subsequent Faro signals.
 * The Faro session id is left untouched. No-op when Faro has not been initialized (e.g. local environment).
 */
export function setFaroUser(dealerId: string, userName: string): void {
  try {
    const api = faro?.api;
    if (!api || !dealerId || !userName) {
      return;
    }

    api.setUser({
      id: `${dealerId}-${userName}`,
      username: userName,
      attributes: { dealerId: String(dealerId) }
    });

    // Dealer as a session attribute (filter sessions by dealer); session id is unchanged.
    const session = api.getSession();
    api.setSession({ ...session, attributes: { ...session?.attributes, dealerId: String(dealerId) } });
  } catch {
    // Telemetry must never break the app.
  }
}

/** Clears the Faro user (e.g. on logout). */
export function resetFaroUser(): void {
  try {
    faro?.api?.resetUser();
  } catch {
    // Telemetry must never break the app.
  }
}
